/*
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-12 08:40:06
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-05 14:23:55
 * @Description: 请求统一拦截器
 */

import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
// import store from '../store';
let httpUrl =
  process.env.NODE_ENV === 'development' ? 'https://jract-dev.jingyugame.com' : process.domain;
// 创建实例
const service = axios.create({
  // baseURL: process.env.BASE_API, // 使用代理，不需要这只该项
  // baseURL: process.env.NODE_ENV === 'development' ? 'http://192.168.28.236:9001' : process.domain, // api的base_url
  baseURL:
    document.location.protocol === 'http:' ? httpUrl.replace('https://', 'http://') : httpUrl, // api的base_url
  timeout: 30000, // 请求超时时间
  // `withCredentials` 表示跨域请求时是否需要使用凭证
  withCredentials: false // 默认 true , 已formData形势提交数据时，该项要注掉或者设置为false
});
// service.defaults.headers.post['Content-Type'] =
//   'application/x-www-form-urlencoded';

// request 拦截器
service.interceptors.request.use(
  config => {
    // if (store.getters.token) {
    //   // Bearer 是 JWT 的认证头部信息
    //   config.headers.common['Authorization'] = 'Bearer ' + store.getters.token;
    // }
    // // console.log(config.data);
    // if (config.data && !config.data.token) {
    //   config.data.token = window.localStorage.getItem('token');
    // }
    // if (config.data && !config.data.platform) {
    //   config.data.platform = 2;
    // }
    // console.log(config, config.headers);
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone 拦截器
service.interceptors.response.use(
  response => {
    // let data = response.data;
    // if (data.success) {
    //   return data;
    // } else {
    //   const err = new Error(data.message);
    //   err.response = response;
    //   return Promise.reject(err);
    // }
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.code !== 200) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      });

      // // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
      //     confirmButtonText: '重新登录',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('FedLogOut').then(() => {
      //       location.reload(); // 为了重新实例化vue-router对象 避免bug
      //     });
      //   });
      // }
      // if ((res.code > 600 && res.code < 604) || res.code === 606) {
      //   window.location.href = `${window.location.href.split('#')[0]}#/account/login`;
      // }
      // return Promise.reject('error');
      return Promise.reject(res.msg);
    } else {
      return response.data;
    }
  },
  error => {
    let errorInfo = {};
    if (error.response) {
      errorInfo.errCode = error.response.status;
    }
    MessageBox.confirm(error.message, '错误', {
      type: 'error'
    });
    return Promise.reject(errorInfo);
  }
);

export default service;
